import { render, staticRenderFns } from "./RidesPerStatusPie.vue?vue&type=template&id=97c04d02&scoped=true&"
import script from "./RidesPerStatusPie.vue?vue&type=script&lang=js&"
export * from "./RidesPerStatusPie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97c04d02",
  null
  
)

export default component.exports